import {
  WSAvatar,
  WSElement,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useHistory } from "react-router-dom";
import { queriesPayerRows } from "@query";
import { selectorSearchRowName } from "../../shared/selectors/selectorSearchRowName";
import { WSQueries } from "../../query/WSQuery";
import { useQueryInvoice } from "../../query/payments/queries";
import { calculateLineItemsTotal } from "../utils";
import { InvoiceRecentUpdate } from "./InvoicesTable/InvoiceRecentUpdate";
import { buildInvoiceIcon } from "./InvoicesTable/buildInvoiceIcon";

type Props = { parentInvoiceId: string };

export const PayableParentInvoice: React.FC<Props> = props => {
  const history = useHistory();

  const queryInvoice = useQueryInvoice(props.parentInvoiceId);
  // Name off the payer search row's server-resolved `profile.resolvedName`,
  // the same string the invoice tables show for this client.
  const queryPayerRow = queriesPayerRows.searchPayerRows.useQuery(
    {
      filter: { id: { eq: queryInvoice.data?.clientId! } },
      page: { size: 1 }
    },
    {
      enabled: !!queryInvoice.data?.clientId,
      retry: false
    }
  );

  return (
    <WSElement>
      <WSText.Heading5 mb="XL">Parent invoice</WSText.Heading5>
      <WSQueries
        queries={{
          queryInvoice,
          queryPayerRow
        }}
      >
        {({
          queryInvoice: { data: invoice },
          queryPayerRow: { data: payerRows }
        }) => {
          const payerRow = payerRows.data?.[0];
          const payerName = payerRow ? selectorSearchRowName(payerRow) : "";
          // TODO (v3-migration): no v3 secondary name

          return (
            <WSFlexBox
              wrap="nowrap"
              justify="space-between"
              alignItems="center"
              onClick={() => {
                history.push("/member/invoices/" + props.parentInvoiceId);
              }}
            >
              <WSFlexBox wrap="nowrap" alignItems="center">
                <WSAvatar.Icon {...buildInvoiceIcon(invoice)} mr="M" />
                <WSElement>
                  <WSText color="gray600">{payerName}</WSText>
                  {/* TODO (v3-migration): no v3 secondary name */}
                </WSElement>
              </WSFlexBox>

              <WSFlexBox direction="column" alignItems="flex-end">
                <WSText mb="XS" color="gray600">
                  {formatMoney(
                    calculateLineItemsTotal(invoice.lineItems),
                    invoice.currency
                  )}
                </WSText>
                <InvoiceRecentUpdate invoice={invoice} />
              </WSFlexBox>
            </WSFlexBox>
          );
        }}
      </WSQueries>
    </WSElement>
  );
};
